export default __webpack_public_path__ + "static/media/video4.1fed2bb5.mp4";